import { render, staticRenderFns } from "./PriyomSmenaAccepted.vue?vue&type=template&id=b4c01ea4&scoped=true&"
import script from "./PriyomSmenaAccepted.vue?vue&type=script&lang=js&"
export * from "./PriyomSmenaAccepted.vue?vue&type=script&lang=js&"
import style0 from "./PriyomSmenaAccepted.vue?vue&type=style&index=0&id=b4c01ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c01ea4",
  null
  
)

export default component.exports